export default __webpack_public_path__ + "static/media/Rissol-De-Atum.b5b5b9b5.jpg";